import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};


@Component({
  selector: 'app-afluencia',
  templateUrl: './afluencia.component.html',
  styleUrls: ['./afluencia.component.css'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ] 
})
export class AfluenciaComponent implements OnInit {
  errMsg:any;
  loading:boolean=false;
  data:any=[];
  fecIni:any = moment();
  fecFin:any = moment();
  dias:any=[];
  totPersonas:number = 0;
  totTotal:number = 0;
  separaDia:boolean=false;
  formato:any=[];
  formStyle:any[];
  elemImp:any[];
  elemStyle:any[]=[]  
  dd:any;
  gpo:any=[];
  idGpo:number=0;
  esFechaEspecial:boolean=false;
  fechaEspecial:any=[];

  thisForm = new FormGroup({
    separaDia: new FormControl(this.separaDia, []),
    gpo: new FormControl(this.idGpo, []),
  });


  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.dataService.getGrupos().subscribe(
                  rows => {   
                          this.gpo = <any>rows
                          },          
                  error => this.errMsg = <any>error,
                  () => this.fnGruposCargados());
    this.dataService.getVars("FEC-TIC").subscribe(
                      rows => {   
                              this.esFechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecialObtenida());
     this.dataService.getFormatoImp(42, 1).subscribe(
                          rows => {   
                                  this.formato = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnFormatoImpCargado());
  }

  fnFechaEspecialObtenida(){
    //console.log(this.esFechaEspecial);
    if(this.esFechaEspecial){
      this.dataService.getFechaEspecial().subscribe(
                      rows => {   
                              this.fechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecial());
    }
    else{
      this.dias.push({'fecha': moment(this.fecIni).format("DD/MM/YYYY"),
                      'personas': this.totPersonas , 
                      'total': this.totTotal
                    });
      this.fnCargaReporte(this.separaDia ? 'SI' : 'NO', this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), this.idGpo);
    }
  }

  fnFechaEspecial(){
    //console.log(this.fechaEspecial);
    this.fechaEspecial = moment(this.fechaEspecial[0].fecha.substr(6,4) + "/" + this.fechaEspecial[0].fecha.substr(3,2) + "/" + this.fechaEspecial[0].fecha.substr(0,2)).format("YYYY/MM/DD");
    this.fecIni = moment(this.fechaEspecial);
    this.fecFin = moment(this.fechaEspecial);
    this.dias.push({'fecha': moment(this.fecIni).format("DD/MM/YYYY"),
                    'personas': this.totPersonas , 
                    'total': this.totTotal
                  });
    setTimeout(() => {
      console.log(this.fecIni)
      this.fnCargaReporte(this.separaDia ? 'SI' : 'NO', this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), this.idGpo);
    }, 50);
  }

  fnGruposCargados(){
    //console.log(this.gpo);
  }

  fnCargaReporte(agrupar: string, fecIni:string, fecFin:string, area:number){
    this.loading=true;
    this.dataService.afluencia(agrupar, fecIni, fecFin, area).subscribe(
                      rows => {   
                              this.data = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnReporteCargado());
  }

  fnReporteCargado(){
    //console.log(this.data);
    this.totPersonas = 0;
    this.totTotal = 0;
    for(var d = 0; d < this.dias.length; d++){
      this.dias[d].personas = 0;
      this.dias[d].total = 0;
    }
    for(var i = 0; i < this.data.length; i++){
      this.totPersonas += this.data[i].personas;
      this.totTotal += this.data[i].tot;
      for(var d = 0; d < this.dias.length; d++){
        if(this.dias[d].fecha == this.data[i].fecha){
          this.dias[d].personas += this.data[i].personas;
          this.dias[d].total += this.data[i].tot;
        }
      }
    }
    this.loading=false;
  }

  fnFormatoImpCargado(){
    //console.log("Formatos: ");
    //console.log(this.formato);
    var arrIdForms = [];
    for(var i = 0; i < this.formato.length; i++){
      arrIdForms.push(this.formato[i].id);
    }
    //--> Obtener styles
    this.dataService.getFormStyles(arrIdForms.join(","), "1,2").subscribe(
                rows => {   
                        this.formStyle = <any>rows
                        },          
                error => this.errMsg = <any>error,
                () => this.fnFormStyleCargado())
  }

  fnFormStyleCargado(){
    //console.log(this.formStyle)
    var arrStyles=[];
    for(var i = 0; i < this.formStyle.length; i++){
      arrStyles.push(this.formStyle[i].style);
    }
    arrStyles = arrStyles.filter(this.dataService.onlyUnique);        
    for(var i = 0; i < arrStyles.length; i++){
      this.elemStyle[arrStyles[i]] = {};
      for(var k = 0; k < this.formStyle.length; k++){
        if(arrStyles[i] == this.formStyle[k].style){
            var auxObj = Object.keys(this.elemStyle[arrStyles[i]]);
            //console.log("Keys of Object:");
            //console.log(auxObj);
            if(auxObj.length == 0)
              this.elemStyle[arrStyles[i]] = {[this.formStyle[k].key]:this.formStyle[k].valor} ;
            else
              this.elemStyle[arrStyles[i]][this.formStyle[k].key]   = this.formStyle[k].valor;
        }
      }
    }
    //console.log(this.elemStyle);
  }

  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    //console.log(tipo);
    //console.log("onClick: " + idEl);
    //console.log(item);
    if(tipo=="GPO"){
      this.idGpo = idEl;
      this.thisForm.controls["gpo"].setValue(this.idGpo);
      this.fnCargaReporte(this.separaDia ? 'SI' : 'NO', moment(this.fecIni).format("YYYYMMDD"), moment(this.fecFin).format("YYYYMMDD"), this.idGpo);
    }   
  }

  fnClickDia(elem:any){
    setTimeout(() => {
      //console.log(this.thisForm.controls["separaDia"].value);
      if(this.thisForm.controls["separaDia"].value){
        this.separaDia = true;
      } 
      else{
        this.separaDia = false;
      }   
      this.fnCambiaFecha("", null);  
    }, 10);
  }
  
  fnCambiaFecha(tipo, obj){
    if (tipo=="INI"){
      this.fecIni = moment(obj.value.format("YYYYMMDD"));
    }
    if (tipo=="FIN"){
      this.fecFin = moment(obj.value.format("YYYYMMDD"));
    }
    this.dias = [];
    if(this.separaDia){
      for(var d = 0; d <= this.fecFin.diff(this.fecIni, "days"); d++){
        var newDate = moment(this.fecIni).add(d, "days");
        this.dias.push({'fecha': newDate.format("DD/MM/YYYY"),
                        'personas': 0,
                        'total': 0
                      })
      }
    }
    else{
      if(moment(this.fecIni).format("DD/MM/YYYY") != moment(this.fecFin).format("DD/MM/YYYY"))
        this.dias.push({'fecha': 'Del ' + moment(this.fecIni).format("DD/MM/YYYY") + ' al ' + moment(this.fecFin).format("DD/MM/YYYY"),
                        'personas': this.totPersonas,
                        'total': this.totTotal
                      })
      else
        this.dias.push({'fecha': moment(this.fecIni).format("DD/MM/YYYY"),
                        'personas': this.totPersonas , 
                        'total': this.totTotal
                      });
    }
    //console.log(this.dias);
    this.fnCargaReporte(this.separaDia ? 'SI' : 'NO', moment(this.fecIni).format("YYYYMMDD"), moment(this.fecFin).format("YYYYMMDD"), this.idGpo);
  }

  fnImprimeReporte(idFormato){
    //console.log("Imprime Reporte");
    this.dataService.insLog(42,'IMPRIMIR', "AFLUENCIA",'').subscribe(
                            row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.getElemFormatoImp(idFormato, "'CONTENT', 'COLUMN', 'CELL', 'NEW_LINE', 'NEW_ROW', 'STYLE', 'POSITION', 'LINE', 'RECT', 'ELLIPSE', 'END DRAW', 'IMAGE', 'GRAF1', 'GRAF2', 'GRAF3', 'GRAF4'", "1,2").subscribe(
                            rows => {   
                                    this.elemImp = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnElementosImpresionCargados(idFormato, 0));              
  }

  fnElementosImpresionCargados(idFormato, ii){
    var index = this.formato.findIndex(x => x.id === idFormato);
    var margins =this.formato[index].pageMargins.split(",");
    var height = 1.0;
    height = this.formato[index].lineHeight;
    var text = [];
    var text2 = [];
    var canvas = [];
    var images = [];  
    
    var auxLogo = <HTMLImageElement>document.getElementById("imgRepLogo");
    auxLogo.src = "../../../assets/logoBlack.png";

    var auxColTit = ["Producto","Personas","Parcial", "Total"];
    var auxColId = ["prod","personas","par", "tot"];
    var auxColumna=[];
    var strCol;
    var auxLen;
    var auxMonto;
    var auxNbsp;
    for(var c=0; c<auxColId.length; c++){
      strCol="";
      for(var r=0; r<this.data.length; r++){
        auxNbsp = "$";
        auxMonto = "";
        if(this.data[r][auxColId[c]]){
          if(c==0){
            if(this.data[r]["descuento"])
              auxLen = this.data[r][auxColId[c]] + '   (' + this.data[r]["descuento"] + ')';
            else
              auxLen = this.data[r][auxColId[c]];
          }
          else 
            auxLen = this.data[r][auxColId[c]];
        }
        else
          auxLen = "";
        if(c == 0 && auxLen.length > 72){
          strCol += auxLen.substr(0,72) + "ƒ" + auxLen.substr(72) + "ƒ";
          continue;
        }
        if(c == 2){
          if(auxLen){
            auxMonto = this.dataService.fnFormatMoney(auxLen, 2).slice(0, -3);  //--> Si pedimos 0 digitos, el regreso es leido como numero en lugar de cadena y pierde el formato de las comas, por lo que se llama con 2 decimales y depués se le quitan tres posiciones (el punto y los dos decimales)
            for(var l = 7; l >=auxMonto.length; l--)
              auxNbsp += " ";
          }
          if(auxMonto.length > 0)
            strCol += auxNbsp + auxMonto + "ƒ ƒ";
          else
            strCol +=  "ƒ ƒ";
          continue;
        }
        if(c == 3){
          if(auxLen){
            auxMonto = this.dataService.fnFormatMoney(auxLen, 2).slice(0, -3);  //--> Si pedimos 0 digitos, el regreso es leido como numero en lugar de cadena y pierde el formato de las comas, por lo que se llama con 2 decimales y depués se le quitan tres posiciones (el punto y los dos decimales)
            for(var l = 12; l >=auxMonto.length; l--)
              auxNbsp += " ";
          }
          if(auxMonto.length > 0){
            //strCol += auxNbsp + auxMonto + "ƒ ƒ";
            //--> Versión Alineada a la derecha:
            strCol += "$ " + auxMonto + "      \u00A0" + "ƒ ƒ";
          }
          else{
            //strCol += auxNbsp + "              0" + "ƒ ƒ";
            //--> Versión Alineada a la derecha:
            strCol += auxNbsp + " 0" + "      \u00A0" + "ƒ ƒ";
          }
          continue;
        }
        strCol += auxLen + "ƒ ƒ";   //--> Row vacío (prepara para Totales)
      }        
      if(c == 0)
        strCol += " " + "ƒ" + "                        TOTALES: "    //-->  Inserta un total multi columna 
      if(c == 1)
        strCol += " " + "ƒ" +this.totPersonas    //-->  Inserta un total         
      if(c == 3){
        auxNbsp = "";
        for(var l = 11; l >=this.totTotal.toString().length; l--)
          auxNbsp += " ";
        //strCol += " " + "ƒ $" + auxNbsp + this.dataService.fnFormatMoney(this.totTotal, 2).slice(0, -3)    //-->  Inserta un total         
        //--> Versión Alineada a la derecha:
        strCol += " " + "ƒ $ " + this.dataService.fnFormatMoney(this.totTotal, 2).slice(0, -3) + "      \u00A0";   //-->  Inserta un total         
        }
      if(c != 4 && c != 5 && c != 6)
        strCol += " " + "ƒ";
      auxColumna.push(strCol);
    }

    var arrSpecialStrings = [{
      'FECHAEMI': this.dias[ii].fecha,
      'FILTRO1': this.idGpo > 0 ? this.dataService.findItemInObject(this.gpo, this.idGpo, "idGrupo").grupo : "",
      'COLTIT': auxColTit,
      'COL': auxColumna
      //'DESCUENTO': (this.idDesc > 0 ? '(' + this.dataService.findItemInObject(this.descs, this.idDesc, "id").descuento + ')' : '')
    }];
    var auxTxtMargen = [0,0,0,0];
    for(var i = 0; i < this.elemImp.length; i++){
      if(this.elemImp[i].tipo == "content"){
        if(this.elemImp[i].margin.indexOf(",") > 0)
          auxTxtMargen = this.elemImp[i].margin.split(",");
          auxTxtMargen = auxTxtMargen.map(function (x) {  
            return parseInt(x.toString(), 10); 
          }); 
        //console.log(auxTxtMargen);   --> NO FUNCIONAN MARGENES EN TEXTO
        text.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    margin: [0,0,0,0],
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment
                  });                  
      }
      if(this.elemImp[i].tipo == "position"){
        text2.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment,                              
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1])}
                  });                  
      }
      if(this.elemImp[i].tipo == 'image' && this.elemImp[i].dato == "ƒLOGO" ){
        images.push({
                    //image:  this.dataService.fnGetBase64Image(auxLogo, auxLogo.naturalWidth, auxLogo.naturalHeight),
                    image: "logoBlack.png",
                    fit: [85, 30],
                    alignment: this.elemImp[i].alignment,
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1]) }
                   })
      }
      if(this.elemImp[i].tipo == 'line'){
          canvas.push({
                      type: 'line',
                      r: 0,
                      x1: parseInt(this.elemImp[i].margin.split(",")[0]),
                      y1: parseInt(this.elemImp[i].margin.split(",")[1]),
                      x2: parseInt(this.elemImp[i].margin.split(",")[2]),
                      y2: parseInt(this.elemImp[i].margin.split(",")[3]),
                      lineColor: this.elemImp[i].color,
                      lineWidth: this.elemImp[i].alignment                               
                    })
      }
      if(this.elemImp[i].tipo == 'rect'){
        canvas.push({
                    type: 'rect',
                    r: 5,
                    fillOpacity: 0.3,
                    color: this.elemImp[i].style,
                    x: parseInt(this.elemImp[i].margin.split(",")[0]),
                    y: parseInt(this.elemImp[i].margin.split(",")[1]),
                    w: parseInt(this.elemImp[i].margin.split(",")[2]),
                    h: parseInt(this.elemImp[i].margin.split(",")[3]),
                    lineColor: this.elemImp[i].color,
                    lineWidth: this.elemImp[i].alignment                               
                  })
      }
    }

    var styles = this.elemStyle;
    var stack = [];
    if (this.formato[index].tipo == "TABLA")
      stack[0] = text;
    else
      stack.push({text:text});
    stack[1] = text2;
    stack.push({canvas:canvas});
    this.dd = {
      //pageSize: this.formato[index].pageSize,
      pageSize: 'letter',
      pageOrientation: this.formato[index].pageOrientation,
      pageMargins: [parseInt(margins[0]), parseInt(margins[1]), parseInt(margins[2]), parseInt(margins[3])],
      content: [
        {
          lineHeight: 1.0,
          alignment: 'left',
          background: 'white',
          color: 'black',
          stack       
        }
        ,images   
      ],
      styles
    }
    //pdfMake.createPdf(this.dd).print();
    pdfMake.createPdf(this.dd).open();
  }


}
